import { createFileRoute } from "@tanstack/react-router";
import { SearchParams } from "@/routes/(inventory)/branch/_layout/reports/supplier-profitability/-data/model";
import { Loading } from "@/layouts/loading";
import Component from "@/routes/(inventory)/branch/_layout/reports/supplier-profitability/-components/component";
import { pharmacyClient } from "@/connect";

export const Route = createFileRoute("/(inventory)/branch/_layout/reports/supplier-profitability/")({
  component: Component,
  validateSearch: SearchParams,
});
